module.exports = __webpack_public_path__ + "img/grid.e0defd60.svg";